/**
 * Selling Plan Handler
 * Manages the custom bundle & subscribe UI interactions
 */

class SellingPlanHandler {
  constructor() {
    this.init();
  }

  init() {
    // Handle bundle variant selection
    this.handleBundleSelection();
    
    // Handle purchase option selection (one-time vs subscription)
    this.handlePurchaseOptionSelection();
    
    // Initialize the default state
    this.updatePriceDisplay();
  }

  handleBundleSelection() {
    const bundleRadios = document.querySelectorAll('.cc-bundle-card__radio');
    
    bundleRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const variantId = e.target.value;
        
        // Update the hidden variant input in the form
        const variantInput = document.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.value = variantId;
          
          // Trigger variant change event
          const event = new CustomEvent('variant:change', {
            detail: { variant: variantId }
          });
          document.dispatchEvent(event);
        }
        
        // Update price displays
        this.updatePriceDisplay();
      });
    });
  }

  handlePurchaseOptionSelection() {
    const purchaseRadios = document.querySelectorAll('.cc-purchase-option__radio');
    
    purchaseRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const sellingPlanId = e.target.value;
        
        // Update the selling plan input in the form
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        if (sellingPlanInput) {
          sellingPlanInput.value = sellingPlanId;
        }
        
        // Trigger selling plan change event
        const event = new CustomEvent('selling_plan:change', {
          detail: { sellingPlan: sellingPlanId }
        });
        document.dispatchEvent(event);
        
        // Update price displays
        this.updatePriceDisplay();
      });
    });
  }

  updatePriceDisplay() {
    // Get selected variant
    const selectedVariantRadio = document.querySelector('.cc-bundle-card__radio:checked');
    const selectedPurchaseRadio = document.querySelector('.cc-purchase-option__radio:checked');
    
    if (!selectedVariantRadio || !selectedPurchaseRadio) return;
    
    const variantId = selectedVariantRadio.value;
    const sellingPlanId = selectedPurchaseRadio.value;
    
    // Update the one-time purchase price display
    this.updateOneTimePurchasePrice(variantId);
    
    // Update subscription price if subscription is selected
    if (sellingPlanId) {
      this.updateSubscriptionPrice(variantId, sellingPlanId);
    }
  }

  updateOneTimePurchasePrice(variantId) {
    const variantRadio = document.querySelector(`.cc-bundle-card__radio[value="${variantId}"]`);
    if (!variantRadio) return;
    
    const variantPrice = variantRadio.dataset.variantPrice;
    if (!variantPrice) return;
    
    // Format price
    const priceInDollars = (parseInt(variantPrice) / 100).toFixed(2);
    const formattedPrice = `$${priceInDollars}`;
    
    // Update one-time purchase display
    const oneTimePriceDisplay = document.querySelector('.cc-purchase-option:not(.cc-purchase-option--subscription) .cc-purchase-option__price');
    if (oneTimePriceDisplay) {
      oneTimePriceDisplay.textContent = formattedPrice;
    }
  }

  updateSubscriptionPrice(variantId, sellingPlanId) {
    const variantRadio = document.querySelector(`.cc-bundle-card__radio[value="${variantId}"]`);
    const subscriptionRadio = document.querySelector('.cc-purchase-option--subscription .cc-purchase-option__radio');
    
    if (!variantRadio || !subscriptionRadio) return;
    
    const variantPrice = parseInt(variantRadio.dataset.variantPrice);
    const discountPercent = parseInt(subscriptionRadio.dataset.discountPercentage || 0);
    
    if (!variantPrice) return;
    
    // Calculate subscription price
    const subscriptionPrice = variantPrice * (1 - discountPercent / 100);
    const formattedSubPrice = `$${(subscriptionPrice / 100).toFixed(2)}`;
    const formattedComparePrice = `$${(variantPrice / 100).toFixed(2)}`;
    
    // Update subscription price display
    const subscriptionPriceDisplay = document.querySelector('.cc-subscription-price');
    if (subscriptionPriceDisplay) {
      subscriptionPriceDisplay.textContent = formattedSubPrice;
    }
    
    // Update subscription compare price
    const subscriptionCompareDisplay = document.querySelector('.cc-subscription-compare-price');
    if (subscriptionCompareDisplay) {
      subscriptionCompareDisplay.textContent = formattedComparePrice;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SellingPlanHandler();
  });
} else {
  new SellingPlanHandler();
}

// Re-initialize if the product form is dynamically loaded
document.addEventListener('product:loaded', () => {
  new SellingPlanHandler();
});
